var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUbiicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.051,
    height: 43,
    viewBox: "0 0 27.051 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21948",
    "data-name": "Group 21948",
    transform: "translate(-0.329 -0.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171300",
    "data-name": "Path 171300",
    d: "M26.977,64.682,16.232,70.388a1.265,1.265,0,0,1-1.183,0L4.3,64.682a1.261,1.261,0,0,1,0-2.226l4.235-2.249c2.2,2.946,4.014,4.982,4.275,5.274a3.81,3.81,0,0,0,5.653,0c.262-.292,2.074-2.329,4.276-5.275l4.235,2.249a1.261,1.261,0,0,1,0,2.226",
    transform: "translate(-1.721 -27.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171302",
    "data-name": "Path 171302",
    d: "M14.276.75A13.3,13.3,0,0,0,.75,13.787c0,9.121,12.061,22.655,12.573,23.226a1.289,1.289,0,0,0,1.905,0c.513-.571,12.573-14.1,12.573-23.226A13.3,13.3,0,0,0,14.276.75m5.706,11.835q-3.029,3.041-6.07,6.07a1.559,1.559,0,0,1-2.4-.008q-1.471-1.461-2.932-2.932a1.564,1.564,0,1,1,2.19-2.219c.636.629,1.257,1.272,2.006,2.032a4.064,4.064,0,0,1,.352-.492q2.321-2.335,4.653-4.659a1.565,1.565,0,1,1,2.2,2.207",
    transform: "translate(-0.421 -0.421)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbiicon);
export default __webpack_public_path__ + "static/media/ubiicon.2889c33ff6f505d2f80f3a792afae689.svg";
export { ForwardRef as ReactComponent };